module.exports = __webpack_public_path__ + "static/media/Work in Progress_1.e9e2b392.png";